module.exports = "<p>\n  social-media works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/System settings/social-media/social-media.component.html
// module id = ./src/app/Dashboard/DashboardPages/System settings/social-media/social-media.component.html
// module chunks = main